module.exports = __webpack_public_path__ + "03af3c3694f1ba291678e429782af1ec.pdf";